import { ApplicationInstanceService } from "@/services/ApiService";

const ApplicationInstance = {
  namespaced: true,
  state: {
    applicaton_instances: [],
    errorState: { error: false, details: {} },
    loaded: false
  },
  actions: {
    async fetchApplicationInstances({ commit }) {
      try {
        commit(
          "setApplicationInstances",
          await ApplicationInstanceService.get()
        );
        commit("setErrorState", { error: false, details: {} });
      } catch (exception) {
        commit("setErrorState", { error: true, details: exception });
      }
    },
    createApplicationInstance({ commit }, payload) {
      return ApplicationInstanceService.post(payload).then((response) =>
        commit("setApplicationInstance", response.data)
      );
    },
  },

  mutations: {
    setApplicationInstances: (state, payload) => {
      state.applicaton_instances = payload.data;
      state.loaded = true;
    },
    setApplicationInstance: (state, payload) =>
      state.applicaton_instances.push(payload),
    setApplicationInstanceStatus: (state, payload) =>
      (state.applicaton_instances = state.applicaton_instances.map((instance) =>
        instance.identity === payload.identity
          ? { ...instance, serverStatus: payload.data.status }
          : instance
      )),
    setErrorState: (state, errorState) => {
      return (state.errorState = Object.assign(
        {},
        {
          error: errorState.error,
          details: errorState.details,
        }
      ));
    },
  },
  getters: {
    instancesLoaded: (state) => {
      return state.loaded;
    },
    getApplicationInstances: (state) => {
      return state.applicaton_instances.filter(el => el.appStatus != "EXITED");
    },
    getApplicationInstancesUnfiltered: (state) => {
      return state.applicaton_instances;
    },
    getApplicationInstanceNameByIdentity: (state) => (identity) => {
      return state.applicaton_instances.find(
        (instance) => instance.identity === identity
      );
    },
    getApplicationInstancesErrorState: (state) => state.errorState,
  },
};

export default ApplicationInstance;
